import { render, staticRenderFns } from "./bindphone.vue?vue&type=template&id=544dc93c&scoped=true&"
import script from "./bindphone.vue?vue&type=script&lang=js&"
export * from "./bindphone.vue?vue&type=script&lang=js&"
import style0 from "./bindphone.vue?vue&type=style&index=0&id=544dc93c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544dc93c",
  null
  
)

export default component.exports